import { FC, ReactNode } from 'react';
import { Stack } from '@o2/ui';
import Divider from './Divider';
import { styled, useMediaQuery, useTheme } from '@mui/material';

export interface ControlsProps {
  children?: ReactNode;
  leftDivider?: boolean;
  rightDivider?: boolean;
}

const StyledControls = styled(Stack, {
  name: 'AppBarInternal',
  slot: 'Controls',
})(({ theme }) => ({
  minHeight: 32,
  alignItems: 'center',
  flexDirection: 'row',
  flexWrap: 'wrap',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
  },
}));

const StyledControlsWrapper = styled('div', {
  name: 'AppBarInternal',
  slot: 'ControlsWrapper',
})(({ theme }) => ({
  minHeight: 32,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
  },
}));

const Controls: FC<ControlsProps> = ({ children, leftDivider, rightDivider, ...other }) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledControlsWrapper {...other}>
      {mdUp && leftDivider && <Divider />}
      <StyledControls divider={smDown ? undefined : <Divider />}>{children}</StyledControls>
      {mdUp && rightDivider && <Divider />}
    </StyledControlsWrapper>
  );
};

Controls.displayName = 'AppBarInternal.Controls';

export default Controls;
